// extracted by mini-css-extract-plugin
module.exports = {"facebook__btn":"Login_facebook__btn__elH_O","google__btn":"Login_google__btn__1g0rd"};